import { useNavigate } from "react-router-dom";
import { TextInput } from "flowbite-react";

export const SearchBasicBar = () => {
  const navigate = useNavigate();
  const handleSearch = (e) => {
    e.preventDefault();
    let query = e.target.search.value.trim();
    fetch("/api/search", {
      method: "POST",
      body: JSON.stringify({ query: query }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        navigate("/search/results", { state: resp });
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flex w-full">
      <div className="grow my-auto py-auto h-fit">
        <form onSubmit={handleSearch} action="">
          <div className="grow flex-row w-full">
            <TextInput
              required
              id="search"
              type="search"
              placeholder="Search for a team, player, or conference"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
